<template>
    <div class="select-city-box">

        <div class="select-history">
            <h3 class="flexBox">
                <span class="flexItem">当前位置</span>
                <i class="icon icon-refresh"></i>
                <span @click="refreshLocation">重新定位</span>
            </h3>
            <span class="s-city position-city" @click="selectCity(positionCity, positionCity + '市')">
                <i class="icon icon-h-location"></i>
                <span class="position" v-text="positionCity"></span>
            </span>
            <template v-if="hasStorage">
                <h3 class="history-title">历史访问城市</h3>
                <!-- <h3 class="history-title">内存：{{storageList}}</h3> -->
                <!-- <h3 class="history-title">渲染：{{storageListFilter}}</h3> -->
                <div class="history-list flexBox">
                    <span v-for="list in storageListFilter" class="s-city" v-text="list" @click="selectCity(list, list + '市')"></span>
                    <span class="s-city s-city-blank"></span>
                    <span class="s-city s-city-blank"></span>
                </div>
            </template>
        </div>

        <template v-for="(list, index) in cityList">
            <city-letter-list :lists="list.CityList" :id="'cityletterlist_' + index" :letter="list.FirstChar" @selectCity="selectCity"></city-letter-list>
        </template>

        <div class="letter-tools flexBox">
            <div class="letter-box-wrap">
                <div class="letter-box" v-for="(letter, index) in cityList" :id="'letterbox' + index" @click="selectLetter(index)" @touchmove="mousemoveletter(index, $event)">
                    <span class="letter" v-text="letter.FirstChar"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { HOME } from '../api'
    import cityLetterList from '../components/cityLetterList'
    export default {
        name: 'selectCity',
        data () {
            return {
                positionCity: '定位中',
                cityList: [],
                maxHistory: 6,
                hasStorage: !localStorage.storageList ? false : JSON.parse(localStorage.storageList).length >= 1,
                storageList: !localStorage.storageList ? [] : JSON.parse(localStorage.storageList)
            }
        },
        mounted () {
            // 初始定位
            new BMap.LocalCity().get( (result) => {
                this.positionCity = result.name.replace(/市$/, '')
            })
            HOME.GetCityMap().then( (res) => {
                this.cityList = res.Data.CityList
            })
        },
        methods: {
            selectCity (shortName, cityName) {

                new BMap.LocalCity().get( (result) => {
                    localStorage.prev_position_city = result.name
                })

                localStorage.cityName = cityName
                let listArr = localStorage.storageList ? JSON.parse(localStorage.storageList) : []

                try {  
                    // 当前选中城市与之前有重复
                    listArr.forEach( (elem, index) => {
                        if (shortName === elem) {
                            // 删除之前重复的
                            listArr.splice(index, 1)
                            // 将当前选中置于最后一条 页面渲染成第一条
                            listArr.push(elem)
                            // 筛选数据写回
                            this.storageList = listArr
                            localStorage.storageList = JSON.stringify(listArr)
                            foreach.break = new Error('StopInteration')
                        }
                    })
                } catch (e) {
                    console.log('已匹配到相同的历史记录，跳出循环。' + e.message)
                    this.$router.push({name: 'home'})
                    return
                }

                // 未匹配到重复数据
                if (listArr.length < this.maxHistory) {
                    listArr.push(shortName)
                    this.storageList = listArr
                    localStorage.storageList = JSON.stringify(listArr)
                } else {
                    listArr.splice(0, 1)
                    listArr.push(shortName)
                    this.storageList = listArr
                    localStorage.storageList = JSON.stringify(listArr)
                }

                this.$router.push({name: 'home'})
            },
            selectLetter (index) {
                let scrollTop = document.getElementById('cityletterlist_' + index).offsetTop
                window.scrollTo(0, scrollTop)
            },
            refreshLocation () {
                this.positionCity = '定位中'
                this.$store.commit('AJAX_REQUEST')
                new BMap.LocalCity().get( (result) => {
                    localStorage.cityName = result.name
                    this.positionCity = result.name.replace(/市$/, '')
                    this.$store.commit('AJAX_RESET_COUNT')
                })
            }
        },
        computed: {
            storageListFilter () {
                var cloneArray = new Array()
                this.storageList.forEach( (elem, index) => {
                    cloneArray.push(elem)
                })

                return cloneArray.reverse()
            }
        },
        components: {
            cityLetterList
        }
    }
</script>

<style lang="scss" scoped>
    .select-city-box {
        // color: #666666;
        color: #696D7F;
        font-size: j(28);
        .select-history {
            padding: j(30) j(50) j(15);
            background: #ffffff;
            h3 {
                font-size: j(28);
                font-weight: normal;
                margin-bottom: j(20);
                .icon { margin-right: j(6); }
            }
            h3.history-title { margin-top: j(5); }
            .history-list {
                flex-wrap: wrap;
                justify-content: space-between;
            }
            .s-city {
                margin-bottom: j(25);
                display: inline-block;
                width: j(200);
                height: j(90);
                line-height: j(90);
                text-align: center;
                // background: #f5f5f5;
                background: #f0f1f2;
                border-radius: j(4);
                .icon {
                    margin-right: j(10);
                }
            }
            .position-city {
                width: j(210);
            }
            .s-city-blank {
                height: 0;
                margin-bottom: 0;
            }
        }
        .letter-tools {
            position: fixed;
            right: j(10);
            top: 0;
            bottom: 0;
            width: j(22);
            .letter-box-wrap {
                flex-direction: column;
            }
            .letter-box {
                font-size: j(24);
                font-weight: bold;
                color: #00bcbc;
                text-align: center;
            }
            .letter-box + .letter-box {
                padding-top: 2px;
            }
            .letter-fixed-zoom {
               .letter-zoom {}
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/selectCity.vue